<template>
  <div class="bg-white" id="benefits">
    <div class="container max-w-7xl mx-auto px-4 py-24">
      <div class="lg:text-center">
        <!-- <p
          class="
            text-base text-yellow-600
            font-semibold
            tracking-wide
            uppercase
            mb-2
          "
        >
          Avantaje
        </p> -->
        <h2
          class="
            text-3xl
            leading-8
            font-bold
            tracking-tight
            text-gray-900
            sm:text-4xl
          "
        >
          Ce avantaje ai?
        </h2>
        <p class="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
          Nu mai alergi să cauți piesa potrivită pe diferite platforme. Noi o
          găsim pentru tine ! Colaboram doar cu parcuri auto de încredere.
        </p>
      </div>

      <div class="mt-10">
        <dl
          class="
            space-y-10
            md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10
          "
        >
          <div v-for="feature in features" :key="feature.name" class="relative">
            <dt>
              <div
                class="
                  absolute
                  flex
                  items-center
                  justify-center
                  h-12
                  w-12
                  rounded-md
                  bg-yellow-500
                  text-white
                "
              >
                <component
                  :is="feature.icon"
                  class="h-6 w-6"
                  aria-hidden="true"
                />
              </div>
              <p class="ml-16 text-lg leading-6 font-medium text-gray-900">
                {{ feature.name }}
              </p>
            </dt>
            <dd class="mt-2 ml-16 text-base text-gray-500">
              {{ feature.description }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import {
  AnnotationIcon,
  GlobeAltIcon,
  LightningBoltIcon,
  ScaleIcon,
  CreditCardIcon,
  ShieldCheckIcon,
} from "@heroicons/vue/outline";

const features = [
  {
    name: "Economisește Bani",
    description:
      "Nu mai dai banii pe 3 produse, că să afli că nu merg, ori nu se potrivesc.",
    icon: ScaleIcon,
  },
  {
    name: "Salvează Timp",
    description:
      "Noi căutam piesa potrivita pentru tine, iar tu poți sta relaxat.",
    icon: LightningBoltIcon,
  },
  {
    name: "Plătește în Siguranță",
    description: "Tranzacții securizate cu cardul, ori la ramburs.",
    icon: CreditCardIcon,
  },
  {
    name: "Garanția Produsului",
    description:
      "Colaborăm doar cu parcuri auto de încredere. Nu tolerăm abaterile.",
    icon: ShieldCheckIcon,
  },
  {
    name: "Notificari Automate",
    description: "Te înștiințam atunci când am găsit piesa auto potrivită ție!",
    icon: AnnotationIcon,
  },
  {
    name: "Interfață Prietenoasă",
    description:
      "Interfață este special concepută pentru a fi modernă, intuitivă și rapidă.",
    icon: GlobeAltIcon,
  },
];

export default {
  setup() {
    return {
      features,
    };
  },
};
</script>
